import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Link } from 'react-router-dom'
import { graphql, Query } from 'react-apollo'
import { request as send } from 'graphql-request'
import { Form, Row, Col, Tag, Button, Icon, Table, Modal, Spin, List, Popconfirm } from 'antd'
import moment from 'moment'
import _get from 'lodash/get'
import _last from 'lodash/last'
import _sortBy from 'lodash/sortBy'
import _sumBy from 'lodash/sumBy'
import compare from '~/App/utils/compare'
import { injectIntl, FormattedMessage, FormattedNumber } from 'react-intl'
import RegistrationSteps from '~/App/components/RegistrationSteps'
import registrationQuery from '~/App/graphql/queries/registration.gql'
import newOrderMutation from '~/App/graphql/mutations/newOrder.gql'
import getAgeCategory from '~/App/utils/getAgeCategory'
import VirtualBib from '~/App/components/VirtualBib'
import Run from '~/App/components/Run'
import RunForm from '~/App/components/RunForm'
import RefundRequestForm from '~/App/components/RefundRequestForm'
import CancelRequestForm from '~/App/components/CancelRequestForm'
import DeliveryAddressPreviewBox from '~/App/components/DeliveryAddressPreviewBox'
import submitRunMutation from '~/App/graphql/mutations/submitRun.gql'
import removeRunMutation from '~/App/graphql/mutations/removeRun.gql'
import createRefundRequestMutation from '~/App/graphql/mutations/createRefundRequest.gql'
import createCancelRequestMutation from '~/App/graphql/mutations/createCancelRequest.gql'
import currentUser from '~/App/graphql/queries/currentUser.gql'
import { Registration } from '~/styles'
import bibNumber from '~/App/utils/bibNumber'
import runEframeImageUrlQuery from '~/App/graphql/queries/runEframeImageUrl.gql'
import ExtraItems from '~/App/components/ExtraItems'
import localeGet from '~/App/utils/localeGet'

const statusColorMap = {
  pending: 'orange',
  verifying: 'orange',
  paid: 'green',
  completed: 'green',
  failed: 'red',
  cancelled: 'red'
}
// const getAgeCategory = ({
//   race: { startTime, ageCategories, ageCategoryDiff },
//   birthDate,
//   gender
// }) => {
//   // TODO: important use race
//   const $birthDate = moment(birthDate).set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
//   const {
//     month, date, hour, minute, second, millisecond
//   } = $birthDate.toObject()
//   let $startTime = moment(startTime).set({
//     month, date, hour, minute, second, millisecond
//   })
//   if (ageCategoryDiff === 'day') {
//     $startTime = moment(startTime).set({
//       hour, minute, second, millisecond
//     })
//   }
//   const fullAge = $startTime.diff($birthDate, 'year') // moment(startTime).year() - moment(birthDate).year()
//   return {
//     category: ageCategories.filter(cat => cat.gender === gender).find(cat => {
//       return (
//         (!cat.min && cat.max >= fullAge) ||
//         (!cat.max && cat.min <= fullAge) ||
//         (cat.min <= fullAge && cat.max >= fullAge)
//       )
//     }),
//     gender
//   }
// }
const thairunUrl = ['localhost:', 'https://race.phuket.run'].find(url =>
  process.env.REACT_APP_BASE_URI.search(url) !== -1) ? 'phuket.run' : 'thai.run'
const orderStatusColors = {
  submitted: 'gold',
  paid: 'green'
}
const taxInvoiceOptions = [{
  _id: 'none',
  en: 'None',
  zh: 'None',
  th: 'ไม่ขอใบกำกับภาษี'
}, {
  _id: 'individual',
  en: 'Individual',
  zh: 'Individual',
  th: 'บุคคล'
}, {
  _id: 'company',
  en: 'Company',
  zh: 'Company',
  th: 'บริษัท'
}]
const receiptOptions = [{
  _id: 'none',
  en: 'None',
  zh: 'None',
  th: 'ไม่ขอใบเสร็จรับเงิน'
}, {
  _id: 'individual',
  en: 'Individual',
  zh: 'Individual',
  th: 'บุคคล'
}, {
  _id: 'company',
  en: 'Company',
  zh: 'Company',
  th: 'บริษัท'
}]

// const ageCategoryString = ({ category, gender }) => {
//   const g = gender ? gender[0].toUpperCase() : ''
//   if (!category) {
//     return 'open'
//   }
//   const { min, max } = category
//   if (!min && max) {
//     return `${g} under ${max + 1}`
//   } else if (min && !max) {
//     return `${g} ${min} up`
//   } else {
//     return `${g} ${min} - ${max}`
//   }
// }

const Eframe = ({variables}) => <Query query={runEframeImageUrlQuery} variables={variables}>
  {({data}) => {
    const runEframeImageUrl = _get(data, 'runEframeImageUrl')
    return <a href={runEframeImageUrl} disabled={!runEframeImageUrl} target="_blank" className="baseBtn">
      <Icon type={ !runEframeImageUrl ? 'loading' : 'eye-o'} />  e-Frame
    </a>
  }}
</Query>

const RemoveRuns = ({data, handleRemoveRun}) => {
  if (!data) return 'loading...'
  const runLength = data.runs.length
  const runList = data.runs.map(run => {
    return <Row key={run._id}>
      <Col span={12}>
        <div className='preview' style={{backgroundImage: `url("${_get(run, 'runnerImage.thumbnail.url')}")`}}></div>
      </Col>
      <Col span={12}>
        <div className='preview' style={{backgroundImage: `url("${_get(run, 'activityImage.thumbnail.url')}")`}}></div>
      </Col>
      <Col span={24} style={{height: '0', position: 'relative', zIndex: '1', textAlign: 'right', bottom: '26px'}}>
        <Popconfirm title="ต้องการลบผลการวิ่งนี้ ?" onConfirm={() => handleRemoveRun({run, runLength})}>
          <Button icon="delete" className="delete">
            {`${run.distance} km`}
          </Button>
        </Popconfirm>
      </Col>
    </Row>
  })
  return <div className="removeRuns">
    {runList}
  </div>
}

const RunResult = ({data}) => {
  if (!data) return 'loading...'
  return <div>
    {['MVRBWR', 'MVRBWR18'].includes(data.event.slug) && data.eframeEnabled && <div><Eframe variables={data.valiables}/></div>}
    {['MVRBWR', 'MVRBWR18'].includes(data.event.slug) && !(data.sumRunDistance >= data.race.distance) && <Button className="eframeDisabled" disabled>
      <Icon type="exclamation-circle" theme="outlined" /> อีก {data.race.distance - data.sumRunDistance} km จะสามารถโหลด e-Frame ได้
    </Button>}
    <br/>
    <a href={`https://run.${thairunUrl}/${data.runSlug}?s=${data.bib}`} target="_blank" className="baseBtn" style={{margin: '8px 0'}}>
      <Icon type="eye-o" /> เช็คส่งผลการวิ่ง
    </a>
    <br/>
    {!data.noEcer && <a href={`https://ecer.thai.run/${data.ecerSlug}/${data.bib}`} target="_blank" className="baseBtn">
      <Icon type="download" /> ดาวน์โหลด e-Cer
    </a>}
  </div>
}
@injectIntl
@inject('i18n')
@inject('router')
@graphql(registrationQuery, {
  options: ({ match: { params: { id } } }) => ({
    variables: { _id: id },
    fetchPolicy: 'network-only'
  })
})
@graphql(newOrderMutation, { name: 'newOrder' })
@graphql(removeRunMutation, { name: 'removeRunMutation' })
@graphql(submitRunMutation, {
  name: 'submitRun',
  options: {
    refetchQueries: [
      { query: currentUser }
    ]
  }
})
@graphql(createRefundRequestMutation, {
  name: 'createRefundRequest'
})
@graphql(createCancelRequestMutation, {
  name: 'createCancelRequest'
})
@observer
class RegistrationView extends Component {
  state = {
    id: '',
    submitting: false,
    refundRequesting: false,
    removeRunsRaceId: false
  }

  runForm = null
  refundForm = null
  cancelForm = null

  handleSubmitRunModalOpen = (ticketId, raceId) => {
    const { location } = this.props.router
    location.query = {
      ...location.query,
      'run.submit': ticketId,
      ...(raceId && { raceId })
    }
  }

  handleRemoveRun = ({run, runLength}) => {
    const {router: {location}, removeRunMutation} = this.props
    const {_id, raceId} = run

    removeRunMutation({
      variables: { _id: _id }
    }).then(res => {
      if (runLength === 1) {
        location.query = {}
      } else {
        location.query = {
          removeRunsRaceId: raceId
        }
      }
    }).catch(e => {
      console.error(e)
      location.query = {}
      this.submitting = true
    })
  }
  handleRemoveRunsModal = ({removeRunsRaceId, removeRunsData}) => {
    const { location } = this.props.router
    location.query = {
      removeRunsRaceId
    }
    this.setState({removeRunsRaceId, removeRunsData})
  }
  handleSubmitRunModalClose = () => {
    const { location } = this.props.router
    const { 'run.submit': ticketId, raceId, ...query } = location.query
    location.query = query
  }
  handleSubmitRun = () => {
    const { registration } = this.props.data
    const { event, participants } = registration
    this.setState({
      submitting: true
    })
    const { form } = this.runForm.props
    form.validateFields((err, values) => {
      if (err) {
        this.setState({ submitting: false })
        return console.error(err)
      }
      const { record, activityImageFile, runnerImageFile } = values
      this.props.submitRun({
        variables: {
          record,
          activityImageFile,
          runnerImageFile
        }
      }).then((result) => {
        this.setState({ submitting: false })
        this.setState({ popModlRunResult: true })
        const bib = bibNumber(record.number, _get(event, 'settings.ticket.numberDigits', 4))
        const participant = participants.find(p => p._id === record.participantId)
        const ticket = _get(participant, 'tickets', []).find(t => t._id === record.ticketItemId)
        let race = _get(ticket, 'ticketType.race')
        const races = _get(ticket, 'ticketType.races', [])
        const allRaces = races.concat(race)
        race = allRaces.find(r => r._id === record.raceId)
        const runSlug = _get(race, 'settings.virtualRun') ? `~${_get(race, 'slug')}` : `${event.slug}`
        const ecerSlug = _get(race, 'settings.virtualRun') ? `${_get(race, 'slug')}` : `${event.slug}`
        const vrSettings = _get(race, 'settings.virtualRun') || _get(event, 'settings.virtualRun')
        const noEcer = _get(vrSettings, 'noEcer')

        const runs = _get(participant, 'runs', [])
        const raceRuns = runs.filter(r => r.raceId === race._id)
        const vrDistanceMode = _get(vrSettings, 'distanceMode')
        const name = `${participant.profile.firstName} ${participant.profile.lastName}`
        const validRuns = raceRuns.filter((r, i, runs) => {
          return vrDistanceMode === 'cumulative' || i === runs.length - 1
        })

        const lastValidRun = _get(result, 'data.submitRun.record')
        let sumRunDistance = _sumBy(validRuns, (v) => v.distance) + lastValidRun.distance
        const fullname = `${participant.profile.firstName}' '${participant.profile.lastName}`
        let valiables = ''
        let eframeEnabled = sumRunDistance >= race.distance && lastValidRun
        // console.log(eframeEnabled)

        if (eframeEnabled) {
          this.setState({ popModlRunResult: true })
          const lastRunnerImage = _get(lastValidRun, 'runnerImage.original.url')
          valiables = {
            'runId': lastValidRun._id,
            'runnerImageUrl': lastRunnerImage,
            'bib': bib,
            'fullname': fullname,
            'slug': event.slug
          }
        }
        if (eframeEnabled && !noEcer) {
          // console.log('oat')
          const query = `
            mutation generateEcer($slug: String!, $record: TimeInput) {
              generateEcer(slug: $slug, record: $record)
            }
          `
          
          send('https://results.thai.run/graphql', query, { slug: runSlug , record: { bib: bib, name: name, race: 'normal' } }).then(data =>
            console.log({data})
          )
        }
        this.setState({
          modalRunResult: {
            thairunUrl,
            runSlug,
            bib,
            ecerSlug,
            noEcer,
            lastValidRun,
            valiables,
            eframeEnabled,
            sumRunDistance,
            race,
            event
          }
        })
      })
    })
  }
  handleRefundRequestModalOpen = () => {
    const { router: { location } } = this.props
    location.query = {
      'reg.refund': true
    }
  }
  handleRefundRequestModalClose = () => {
    const { location } = this.props.router
    const { 'reg.refund': regRefund, ...query } = location.query
    location.query = query
  }
  handleCreateRefundRequest = () => {
    this.setState({
      refundRequesting: true
    })
    const { form } = this.refundForm.props
    form.validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }
      const { record } = values
      this.props.createRefundRequest({
        variables: {
          record
        }
      }).then((result) => {
        this.setState({ refundRequesting: false })
        this.handleRefundRequestModalClose()
      })
    })
  }
  handleCancelRequestModalOpen = () => {
    const { router: { location } } = this.props
    location.query = {
      'reg.cancel': true
    }
  }
  handleCancelRequestModalClose = () => {
    const { location } = this.props.router
    const { 'reg.cancel': regCancel, ...query } = location.query
    location.query = query
  }
  handleCreateCancelRequest = () => {
    this.setState({
      cancelRequesting: true
    })
    const { form } = this.cancelForm.props
    form.validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }
      const { record } = values
      this.props.createCancelRequest({
        variables: {
          record
        }
      }).then((result) => {
        this.setState({ cancelRequesting: false })
        this.handleCancelRequestModalClose()
      })
    })
  }
  handleNewOrder = async () => {
    const { data: { registration }, router } = this.props
    const eventId = _get(registration, 'eventId')
    const registrationId = _get(registration, '_id')
    const result = await this.props.newOrder({
      variables: {
        record: {
          eventId,
          registrationId
        }
      }
    })
    const orderId = _get(result, 'data.newOrder.record._id')
    router.push(`/orders/${orderId}/edit`)
  }

  handleRunClick = (runId) => {
    const { location } = this.props.router
    location.query = {
      ...location.query,
      runId
    }
  }

  handleCloseRun = () => {
    const { location } = this.props.router
    const { runId, ...query } = location.query
    location.query = query
  }

  ageCategoryString = ({ category, gender }) => {
    const g = gender ? gender[0].toUpperCase() : ''
    if (!category) {
      return <FormattedMessage id="app.ageCategories.open" />
    }
    const { min, max } = category
    if (!min && max) {
      return <FormattedMessage id="app.ageCategories.under" values={{ gender: g, upper: max + 1 }} />
      // return `${g} under ${max + 1}`
    } else if (min && !max) {
      return <FormattedMessage id="app.ageCategories.over" values={{ gender: g, lower: min }} />
      // return `${g} ${min} up`
    } else {
      return <FormattedMessage id="app.ageCategories.between" values={{ gender: g, lower: min, upper: max }} />
      // return `${g} ${min} - ${max}`
    }
  }

  handleSubmit = ({ registrationId }) => {
    this.props.submitRegistration({
      variables: { _id: registrationId }
    })
    // .then(console.log) // redirect to pay
  }

  render () {
    const { data, router, i18n: { locale }, intl } = this.props
    const {
      'run.submit': ticketId,
      'reg.refund': regRefund,
      'reg.cancel': regCancel,
      runId,
      raceId,
      removeRunsRaceId
    } = router.location.query
    const eventProducts = _get(data, 'registration.eventProducts', [])
    const { registration } = data
    const deliveryAddress = _get(registration, 'deliveryAddress')
    // const { search } = this.props.location
    // const { l: locale = 'en' } = queryString.parse(search)
    // console.log(locale)
    if (data.loading) {
      return <div className="modLoadding">
        <Spin tip="Loading..." size="large" />
      </div>
    }
    if (!registration) {
      return <div>Registration not found...</div>
    }
    const {
      // _id,
      expireAt,
      expired,
      event,
      participants,
      amount,
      itemsAmount,
      status,
      registrationType,
      couponCodes,
      payment,
      payments,
      // refundRequests,
      cancelRequests
    } = registration
    const deliverOneAddressEnabled = _get(registrationType, 'deliveryOptions.length') > 0
    const selectedDeliveryOption = deliverOneAddressEnabled ? _get(registrationType, 'deliveryOptions').find(o => o._id === registration.deliveryOptionId) : null
    const hideNumber = _get(event, 'settings.ticket.hideNumber')
    const systemFee = _get(event, 'settings.registration.fee', 0)
    const gatewayFee = _get(payment, 'payAmount') - _get(payment, 'amount')
    // const virtualBibs = _get(event, 'settings.ticket.virtualBibs', []) || []
    const numberDigits = _get(event, 'settings.ticket.numberDigits', 4) || 4
    // console.log({ hideNumber }, event.settings)
    // successfulPayment
    // const currentPeriod = periods.find(period =>
    //   moment().isBetween(period.start, period.end)
    // )
    const ticketCount = registration.participants.reduce((count, participant) =>
      count + participant.tickets.length
      , 0
    )
    const crossSaleOrderItems = registration.orderItems.filter(o => o.masterType === 'Registration')
    const extraSaleOrderItems = registration.orderItems.filter(o => o.masterType === 'Order')
    // console.log({ ticketCount })
    const $paymentStatus = ({
      paid: <Tag color="green" className="status"><FormattedNumber value={_get(amount, 'discounted')}/>  THB ({
        <FormattedMessage id="paymentStatus.paid" defaultMessage="Paid" />
      })</Tag>,
      payment_verifying: (
        <Tag color="yellow" className="status"><FormattedNumber value={_get(amount, 'discounted')}/>  THB ({
          <FormattedMessage id="paymentStatus.verifying" defaultMessage="Pending Verification" />
        })</Tag>
      ),
      '': <Tag color="orange" className="status"><FormattedNumber value={_get(amount, 'discounted')}/>  THB ({
        <FormattedMessage id="paymentStatus.pending" defaultMessage="Pending Payment" />
      })</Tag>
    })[status || '']
    const { discounted, discount, total, deliveryPrice } = amount
    const discountedItemsAmount = _get(itemsAmount, 'discounted', 0)
    // const refundRequestEnabled = participants.filter(p =>
    //   p.tickets.find(t =>
    //     _get(t, 'ticketType.settings.refundRequest.enabled') &&
    //     !refundRequests.map(r => r.ticketItemId).includes(t._id)
    //   )
    // ).length > 0
    const cancelRequestEnabled = participants.filter(p =>
      p.tickets.find(t =>
        _get(t, 'ticketType.settings.cancelRequest.enabled') &&
        !cancelRequests.map(r => r.ticketItemId).includes(t._id)
      )
    ).length > 0
    return (
      <Registration className="EventRegisterPage" key="">
        <Form
          onSubmit={this.handleSubmitRegistration}
          className="innerEventRegisterPage"
        >
          <div className="dividedBox">
            <div className="registrationTopTitle">
              {localeGet(event, 'name', locale)}
              <div style={{fontSize: '17px', fontWeight: '100'}}>
                {localeGet(registrationType, 'name', locale)}
              </div>
            </div>
            <RegistrationSteps step="complete" />
          </div>
          <div>
            <Row>
              <Col xs={24}>
                {deliverOneAddressEnabled && <div className="deliverOptionsWrapper dividedBox">
                  <h1>
                    รูปแบบการจัดส่ง
                  </h1>
                  {_get(selectedDeliveryOption, `name[${locale}]`)}
                </div>}
                {deliverOneAddressEnabled && _get(selectedDeliveryOption, 'enabled') && deliveryAddress && <div className="dividedBox">
                  <DeliveryAddressPreviewBox deliveryAddress={deliveryAddress} locale={locale}/>
                </div>}
              </Col>
              <Col xs={24}>
                <div className="dividedBox">
                  <h1>
                    {{
                      en: 'Reg. No.',
                      zh: 'Reg. No.',
                      th: 'ใบสมัคร'
                    }[locale]}: {registration.code}
                  </h1>
                  <div>
                    <FormattedMessage id="app.race_day" defaultMessage="Race Day" /> : {moment(event.startDate).format('Do MMMM YYYY')}
                    {event.endDate && `- ${moment(event.endDate).format('Do MMMM YYYY')}`}
                  </div>
                  {$paymentStatus}
                  {!['paid', 'payment_verifying'].includes(status) && expireAt &&
                    (expired
                      ? <Tag color="red" className="status">
                        <FormattedMessage id="app.expired" defaultMessage="Expired" />
                      </Tag>
                      : <Tag color="orange" className="status">
                        <FormattedMessage id="app.payBeforeDate" defaultMessage="Please pay before {date}" values={{
                          date: moment(expireAt).format('Do MMMM HH:mm')
                        }}/>
                      </Tag>
                    )
                  }
                  <div style={{ marginTop: 12 }} >การชำระเงินครั้งล่าสุด</div>
                  <Row>
                    {payments.map(payment => {
                      const [gateway] = payment.method.split('_')
                      const errorCode = _get(payment, ['data', gateway, 'errorCode'])
                      return (
                        <Col xs={24} sm={12} key={payment._id} style={{
                          padding: 6,
                          border: '1px solid gainsboro',
                          borderRadius: 6,
                          marginBottom: 12
                         }}>
                         <div style={{ marginBottom: 6 }}>
                          <Tag color="blue">{payment.payAmount} THB</Tag>
                          <span style={{ fontWeight: 'bold' }}><FormattedMessage id={`paymentMethod.${payment.method}`} defaultMessage="[Payment Method]" /></span>
                         </div>
                         <div style={{ marginBottom: 6 }}>
                          <Tag color={statusColorMap[payment.status]}><FormattedMessage id={`payment.status.${payment.status}`} defaultMessage="" /></Tag>
                          {errorCode && <span style={{ color: 'red' }}><FormattedMessage id={`${gateway}.errors.${errorCode}`} defaultMessage="Payment processing failed" /></span>}
                         </div>
                        </Col>
                      )
                    })}
                  </Row>
                  {participants.map(participant => {
                    const taxInvoiceChoiceEnabled = (_get(event, 'settings.participant.fields', []) || []).find(f => f.name === 'taxInvoice' && f.enabled)
                    const taxInvoiceTypeId = _get(participant, 'profile.taxInvoice.type')
                    const taxInvoiceType = taxInvoiceOptions.find(o => o._id === taxInvoiceTypeId)
                    const receiptChoiceEnabled = (_get(event, 'settings.participant.fields', []) || []).find(f => f.name === 'receipt' && f.enabled)
                    const receiptTypeId = _get(participant, 'profile.receipt.type')
                    const receiptType = receiptOptions.find(o => o._id === receiptTypeId)
                    const emergencyContact = _get(participant, 'profile.emergencyContact')
                    const runs = _get(participant, 'runs', [])
                    return <Row
                      className="registrationPreviewDetailBox"
                      key={participant._id}
                    >
                      <Col xs={24} sm={12}>
                        <div className="code-box-title">
                          {`${({
                            en: 'Participant #',
                            zh: 'Participant #',
                            th: 'ผู้สมัครคนที่ '
                          })[locale]}${participant.order + 1}`}
                        </div>
                        {participant.profile.imageUrl && <div className="eventBottomDetailBox">
                          <span className="eventBottomDetailTitle">
                            {
                              {
                                en: 'Straight face photo',
                                zh: 'Straight face photo',
                                th: 'ภาพถ่ายหน้าตรง'
                              }[locale]
                            }
                          </span>
                          <span className="eventBottomDetailData">
                            <img src={participant.profile.imageUrl} alt="identification" style={{ maxWidth: 100 }}/>
                            {_get(participant, 'profile.imageValidation.errors', []).map(error =>
                              <div key={error} style={{ color: 'orange' }}><FormattedMessage id={`api.faceValidate.${error}`} /></div>
                            // intl.formatMessage({ id: `api.faceValidate.${error}` })
                            )}
                          </span>
                        </div>}
                        <div className="eventBottomDetailBox">
                          <span className="eventBottomDetailTitle">
                            {participant.profile.firstName}{' '}
                            {participant.profile.lastName}{' '}
                          </span><br/>
                          <span className="eventBottomDetailData">
                            ({participant.profile.gender}{participant.profile.nationality && `, ${participant.profile.nationality}`})<br/>
                            {moment(participant.profile.birthDate).format(
                              'D MMMM YYYY'
                            )}<br/>
                            {participant.profile.email}{' '}<br/>
                            (<Icon type="phone" /> {participant.profile.telephone})
                          </span>
                        </div>
                        {participant.profile.nationalId && <div className="eventBottomDetailBox">
                          <span className="eventBottomDetailTitle">
                            {{ en: 'National ID / Passport ID', zh: 'National ID / Passport ID', th: 'เลขประจำตัวประชาชน' }[locale]}
                          </span>
                          <span className="eventBottomDetailData">
                            {participant.profile.nationalId}
                          </span>
                        </div>}
                        {participant.profile.street && <div className="eventBottomDetailBox">
                          <span className="eventBottomDetailTitle">
                            {{ en: 'Address', zh: 'Address', th: 'ที่อยู่' }[locale]}
                          </span>
                          <span className="eventBottomDetailData">
                            {participant.profile.street}
                          </span>
                        </div>}
                        {participant.profile.locality && <div className="eventBottomDetailBox">
                          <span className="eventBottomDetailTitle">
                            {{ en: 'Locality', zh: 'Locality', th: 'ตำบล/แขวง' }[locale]}
                          </span>
                          <span className="eventBottomDetailData">
                            {participant.profile.locality}
                          </span>
                        </div>}
                        {participant.profile.city && <div className="eventBottomDetailBox">
                          <span className="eventBottomDetailTitle">
                            {{ en: 'City', zh: 'City', th: 'อำเภอ/เขต' }[locale]}
                          </span>
                          <span className="eventBottomDetailData">
                            {participant.profile.city}
                          </span>
                        </div>}
                        {participant.profile.province && <div className="eventBottomDetailBox">
                          <span className="eventBottomDetailTitle">
                            {{ en: 'Province of Residence', zh: 'Province of Residence', th: 'จังหวัดที่พักอาศัย' }[locale]}
                          </span>
                          <span className="eventBottomDetailData">
                            {participant.profile.province}
                          </span>
                        </div>}
                        {participant.profile.country && <div className="eventBottomDetailBox">
                          <span className="eventBottomDetailTitle">
                            {{ en: 'Country of Residence', zh: 'Country of Residence', th: 'ประเทศที่พักอาศัย' }[locale]}
                          </span>
                          <span className="eventBottomDetailData">
                            {participant.profile.country}
                          </span>
                        </div>}
                        {taxInvoiceTypeId !== 'none' && (taxInvoiceChoiceEnabled && taxInvoiceType) &&
                          <div>
                            <div className="eventBottomDetailBox">
                              <span className="eventBottomDetailTitle">
                                {{ en: 'Tax Invoice', zh: 'Tax Invoice', th: 'ใบกำกับภาษี' }[locale]}
                              </span>
                              <span className="eventBottomDetailData">
                              {localeGet(taxInvoiceType, '', locale)}
                              </span>
                            </div>
                            {taxInvoiceTypeId !== 'none' && [
                              <div className="eventBottomDetailBox" key="taxId">
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'Tax ID', zh: 'Tax ID', th: 'หมายเลขประจำตัวผู้เสียภาษี' }[locale]}
                                </span>
                                <span className="eventBottomDetailData">
                                  {_get(participant, 'profile.taxInvoice.taxId')}
                                </span>
                              </div>,
                              <div className="eventBottomDetailBox" key="address">
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'Address', zh: 'Address', th: 'ที่อยู่' }[locale]}
                                </span>
                                <span className="eventBottomDetailData">
                                  {_get(participant, 'profile.taxInvoice.address')}
                                </span>
                              </div>]}
                          </div>
                        }
                        {receiptTypeId !== 'none' && (receiptChoiceEnabled && receiptType) &&
                          <div>
                            <div className="eventBottomDetailBox">
                              <span className="eventBottomDetailTitle">
                                {{ en: 'Tax Invoice', zh: 'Tax Invoice', th: 'ใบกำกับภาษี' }[locale]}
                              </span>
                              <span className="eventBottomDetailData">
                              {localeGet(receiptType, '', locale)}
                              </span>
                            </div>
                            {receiptTypeId !== 'none' && [
                              <div className="eventBottomDetailBox" key="taxId">
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'Tax ID', zh: 'Tax ID', th: 'หมายเลขประจำตัวผู้เสียภาษี' }[locale]}
                                </span>
                                <span className="eventBottomDetailData">
                                  {_get(participant, 'profile.receipt.taxId')}
                                </span>
                              </div>,
                              <div className="eventBottomDetailBox" key="address">
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'Address', zh: 'Address', th: 'ที่อยู่' }[locale]}
                                </span>
                                <span className="eventBottomDetailData">
                                  {_get(participant, 'profile.receipt.address')}
                                </span>
                              </div>]}
                          </div>
                        }
                        {emergencyContact &&
                          <div>
                            <div className="eventBottomDetailBox">
                              <span className="eventBottomDetailTitle">
                                {{ en: 'Emergency Contact', zh: 'Emergency Contact', th: 'ผู้ติดต่อกรณีฉุกเฉิน' }[locale]}
                              </span>
                              <span className="eventBottomDetailData">
                                {emergencyContact.name}
                              </span>
                            </div>
                            <div className="eventBottomDetailBox">
                              <span className="eventBottomDetailTitle">
                                {{ en: 'Emergency Contact Relationship', zh: 'Emergency Contact Relationship', th: 'ความสัมพันธ์ผู้ติดต่อ' }[locale]}
                              </span>
                              <span className="eventBottomDetailData">
                                {emergencyContact.relationship}
                              </span>
                            </div>
                            <div className="eventBottomDetailBox">
                              <span className="eventBottomDetailTitle">
                                {{ en: 'Emergency Contact Phone Number', zh: 'Emergency Contact Phone Number', th: 'โทรศัพท์ผู้ติดต่อกรณีฉุกเฉิน' }[locale]}
                              </span>
                              <span className="eventBottomDetailData">
                                {emergencyContact.phone}
                              </span>
                            </div>
                          </div>
                        }
                      </Col>
                      <Col xs={24} sm={12}>
                        {participant.tickets.map(ticket => {
                          const virtualBib = _get(ticket, 'ticketType.virtualBib')
                          const race = _get(ticket, 'ticketType.race')
                          const races = _get(ticket, 'ticketType.races', [])
                          const allRaces = races.length > 0 ? races : [race]
                          // const vrSettings = _get(race, 'settings.virtualRun')
                          // const vrPeriod = _get(vrSettings, 'period')
                          // const vrDistanceMode = _get(vrSettings, 'distanceMode')
                          // const canSubmitRun =
                          //   vrSettings && moment().isBetween(vrPeriod.start, vrPeriod.end)
                          //  && (vrDistanceMode === 'cumulative' || (vrDistanceMode === 'recent' && runs.length === 0))
                          return <div key={ticket._id} style={{ ...(ticket.cancelled && { textDecoration: 'line-through' }) }}>
                            <div className="eventBottomDetailBox">
                              <span className="eventBottomDetailTitle">
                                {{ en: 'Race', zh: 'Race', th: 'ประเภทการแข่งขัน' }[locale]}
                              </span>
                              <span className="eventBottomDetailData">
                                {localeGet(ticket, 'ticketType.name', locale)} <Tag color="blue">{ticket.ticketType.price} THB</Tag>
                                {ticket.cancelled && <Tag color="red">{{ en: 'cancelled', zh: 'cancelled', th: 'ยกเลิกแล้ว' }[locale]}</Tag>}
                              </span>
                            </div>
                            {_get(ticket, 'ticketType.race.ageCategories') && <div className="eventBottomDetailBox">
                              <span className="eventBottomDetailTitle">
                                {{ en: 'Category', zh: 'Category', th: 'รุ่นอายุ' }[locale]}
                              </span>
                              <span className="eventBottomDetailData">
                                {this.ageCategoryString(
                                  getAgeCategory({
                                    race: ticket.ticketType.race,
                                    birthDate:
                                      participant.profile.birthDate,
                                    gender: participant.profile.gender
                                  })
                                )}
                              </span>
                            </div>}
                            {ticket.trackingCode && (
                              <div className="eventBottomDetailBox" >
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'Tracking Code', zh: 'Tracking Code', th: 'รหัสติตามพัสดุ' }[locale]}
                                </span>
                                <span className="eventBottomDetailData" style={{ marginRight: 6 }}>
                                  {ticket.trackingCode}
                                </span>
                              </div>
                            )}
                            {ticket.reservedNumber && (
                              <div>
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'BIB Number (VIP)', zh: 'BIB Number (VIP)', th: 'เลขบิบ (VIP)' }[locale]}
                                </span>
                                <span className="eventBottomDetailData">
                                  {bibNumber(ticket.reservedNumber, _get(event, 'settings.ticket.numberDigits', 4))}
                                </span>
                              </div>
                            )}
                            {ticket.nameOnBib &&
                                <div>
                                  <span className="eventBottomDetailTitle">
                                    {{ en: 'Name On BIB', zh: 'Name On BIB', th: 'ชื่อบนเบอร์วิ่ง' }[locale]}
                                  </span>
                                  <span className="eventBottomDetailData">
                                    {ticket.nameOnBib}
                                  </span>
                                </div>
                            }
                            {_sortBy(ticket.options, ['question.order']).map(option => {
                              const items = _get(option, 'question.items', [])
                              const optionValue = {
                                Open: option.value,
                                Choice: localeGet(items.find(i => i._id === option.itemId), 'value', locale) || option.itemId,
                                MultiChoice: items.filter(i => option.itemIds && option.itemIds.includes(i._id)).map(i => localeGet(i, 'value', locale)).join(', ')
                              }[option.question.kind]
                              const valueFormatted = option.question.inputType === 'date' ? moment(optionValue).format('D MMMM YYYY') : optionValue
                              if (option.question.inputType === 'heading') {
                                return (
                                  <div
                                    key={option._id}
                                    className="eventBottomDetailBox"
                                    style={{ marginTop: '12pt' }}
                                  >
                                    <span className="eventBottomDetailTitle">
                                      [{localeGet(option, 'question.name', locale)}]
                                    </span>
                                  </div>
                                )
                              }
                              if (_get(option, 'question.inputType') === 'shirtTypes') {
                                return (
                                  <div
                                    key={option._id}
                                    className="eventBottomDetailBox"
                                  >
                                    <span className="eventBottomDetailTitle">
                                      {localeGet(option, 'question.name', locale)}
                                    </span>
                                    <span className="eventBottomDetailData">
                                      {localeGet(event.shirtTypes.find(st => st._id === option.shirtTypeId), 'name', locale)}&nbsp;
                                      {localeGet(event.shirts.find(s => s._id === option.shirtId), 'name', locale)}
                                    </span>
                                  </div>
                                )
                              }
                              if (!valueFormatted) {
                                return <div key={option._id} />
                              }
                              const condition = _get(option, 'question.condition')
                              if (_get(condition, 'questionId')) {
                                const questions = _get(ticket, 'ticketType.questions')
                                const condQuestionIndex = questions.findIndex(q => q._id === condition.questionId)
                                const condQuestion = questions[condQuestionIndex]
                                const condOption = _get(ticket, 'options', []).find(o => `${o.questionId}` === `${condQuestion._id}`)
                                const condOptionField = {
                                  Open: 'value',
                                  Choice: 'itemId',
                                  MultiChoice: 'itemIds'
                                }[condQuestion.kind]
                                const value = _get(condOption, `${condOptionField}`)
                                if (!compare(value, condition.operator, condition.value)) {
                                  return <div key={option._id} />
                                }
                              }
                              return (
                                <div
                                  key={option._id}
                                  className="eventBottomDetailBox"
                                >
                                  <span className="eventBottomDetailTitle">
                                    {localeGet(option, 'question.name', locale)}
                                  </span>
                                  <span className="eventBottomDetailData">
                                    {valueFormatted}
                                  </span>
                                </div>
                              )
                            })}
                            {event.shirts.length > 0 && ticket.shirtId &&
                              <div
                                key="shirt"
                                className="eventBottomDetailBox"
                              >
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'Shirt', zh: 'Shirt', th: 'เสื้อ' }[locale]}
                                </span>
                                <span className="eventBottomDetailData">
                                  {localeGet(event.shirtTypes.find(st => st._id === ticket.shirtTypeId), 'name', locale)}&nbsp;
                                  {localeGet(event.shirts.find(s => s._id === ticket.shirtId), 'name', locale)}
                                </span>
                              </div>
                            }
                            {event.finisherShirts && event.finisherShirts.length > 0 && ticket.finisherShirtId &&
                              <div key="finisher-shirt" className="eventBottomDetailBox">
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'Finisher Shirt', zh: 'Finisher Shirt', th: 'เสื้อ finisher' }[locale]}
                                </span>
                                <span className="eventBottomDetailData">
                                  {event.finisherShirtTypes && localeGet(event.finisherShirtTypes.find(st => st._id === ticket.finisherShirtTypeId), 'name', locale)}&nbsp;
                                  {event.finisherShirts && localeGet(event.finisherShirts.find(s => s._id === ticket.finisherShirtId), 'name', locale)}
                                </span>
                              </div>
                            }
                            {!hideNumber && ticket.number && (
                              <div className="eventBottomDetailBox" >
                                <span className="eventBottomDetailTitle">
                                  {{ en: 'Applicant Number', zh: 'Applicant Number', th: 'หมายเลขผู้สมัคร' }[locale]}
                                </span>
                                <span className="eventBottomDetailData" style={{ marginRight: 6 }}>
                                  {bibNumber(ticket.number, _get(event, 'settings.ticket.numberDigits', 4))}
                                </span>
                                {virtualBib &&
                                  <VirtualBib {...virtualBib} name={ticket.nameOnBib || participant.profile.firstName} number={ticket.number} numberDigits={numberDigits} />
                                }
                                {allRaces.filter(race => {
                                  const vrSettings = _get(race, 'settings.virtualRun') || _get(event, 'settings.virtualRun')
                                  const vrPeriod = _get(vrSettings, 'period')
                                  // const vrDistanceMode = _get(vrSettings, 'distanceMode')
                                  const canSubmitRun =
                                      vrSettings && moment().isBetween(vrPeriod.start, vrPeriod.end)
                                      // && (vrDistanceMode === 'cumulative' || (vrDistanceMode === 'recent' && runs.filter(r => r.raceId === race._id).length === 0))
                                  return canSubmitRun
                                }).map(race => {
                                  const vrSettings = _get(race, 'settings.virtualRun') || _get(event, 'settings.virtualRun')
                                  const vrDistanceMode = _get(vrSettings, 'distanceMode')
                                  const noEcer = _get(vrSettings, 'noEcer')
                                  const raceRuns = runs.filter(r => r.raceId === race._id)
                                  const runSubmitted = raceRuns.length > 0
                                  const runSlug = _get(race, 'settings.virtualRun') ? `~${_get(race, 'slug')}` : `${event.slug}`
                                  const ecerSlug = _get(race, 'settings.virtualRun') ? `${_get(race, 'slug')}` : `${event.slug}`
                                  const validRuns = raceRuns.filter((r, i, runs) => {
                                    return vrDistanceMode === 'cumulative' || i === runs.length - 1
                                  })
                                  const lastValidRun = _last(validRuns)
                                  const bib = bibNumber(ticket.number, _get(event, 'settings.ticket.numberDigits', 4))
                                  const fullname = `${participant.profile.firstName}' '${participant.profile.lastName}`

                                  let valiables = ''
                                  let sumRunDistance = _sumBy(validRuns, (v) => v.distance)
                                  let eframeEnabled = sumRunDistance >= race.distance && lastValidRun

                                  if (eframeEnabled) {
                                    const lastRunnerImage = _get(lastValidRun, 'runnerImage.original.url')
                                    valiables = {
                                      'runId': lastValidRun._id,
                                      'runnerImageUrl': lastRunnerImage,
                                      'bib': bib,
                                      'fullname': fullname,
                                      'slug': event.slug
                                    }
                                  }
                                  let removeRunsData = {}
                                  if (runSubmitted) {
                                    removeRunsData = {
                                      runs: validRuns,
                                      locale
                                    }
                                    if (removeRunsRaceId === race._id && this.state.removeRunsRaceId !== removeRunsRaceId) {
                                      this.setState({removeRunsRaceId, removeRunsData})
                                    }
                                  }
                                  // const run = runSubmitted && raceRuns[raceRuns.length - 1]
                                  return (<div key={race._id} className={`${runSubmitted ? `runSubmittedBox` : ``}`}>
                                    {runSubmitted && vrDistanceMode === 'recent'
                                      ? <React.Fragment key={race._id}>
                                        <Button key={race._id} size="small" type="primary" icon="edit" className="canSubmitRunBtn" onClick={() => this.handleSubmitRunModalOpen(ticket._id, race._id)}>{{ en: 'Edit Activity', th: 'แก้ไขผลการวิ่ง' }[locale]} {localeGet(race, 'name', locale)} <Icon type="check-circle" /></Button>
                                        {validRuns.map(run =>
                                          <div key={run._id} style={{ border: '1px solid gainsboro', borderRadius: '3px', padding: 3, marginBottom: 6 }} >
                                            <Tag color="green" className="status" >{localeGet(race, 'name', locale)}: {run.distance} km</Tag><br />
                                            {run.activityImage && <img src={_get(run, 'activityImage.thumbnail.url')} alt="activity" className="run activityImage" style={{ maxHeight: 100, maxWidth: '100%' }} />}
                                            {run.runnerImage && <img src={_get(run, 'runnerImage.thumbnail.url')} alt="activity" className="run runnerImage" style={{ maxHeight: 100, maxWidth: '100%' }} />}
                                          </div>
                                        )}
                                      </React.Fragment>
                                      : <Button 
                                          key={race._id} 
                                          size="small" 
                                          type="primary" 
                                          icon="download" 
                                          className="canSubmitRunBtn" 
                                          onClick={() => this.handleSubmitRunModalOpen(ticket._id, race._id)}>
                                          {{ en: 'Submit Activity', th: 'ส่งผลการวิ่ง' }[locale]} 
                                          {localeGet(race, 'name', locale)}
                                          {' '}
                                          {vrDistanceMode === 'recent'
                                            ? `${{ en: '(recent)', th: '(ส่งครั้งเดียว)' }[locale]}`
                                            : `${{ en: '(cumulative)', th: '(สะสมระยะ)' }[locale]}`
                                          } 
                                          {runSubmitted && <Icon type="check-circle" />}
                                        </Button>
                                    }
                                    {runSubmitted && vrDistanceMode === 'cumulative' &&
                                      <Button size="small" type="primary" icon="delete" onClick={() => this.handleRemoveRunsModal({removeRunsRaceId: race._id, removeRunsData})}>
                                        {{ en: 'select runs to delete', th: 'เลือกผลการวิ่งที่จะลบ' }[locale]}
                                      </Button>}
                                    {runSubmitted && <div>
                                      {['MVRBWR', 'MVRBWR18'].includes(event.slug) && eframeEnabled && <div><Eframe variables={valiables}/></div>}
                                      {['MVRBWR', 'MVRBWR18'].includes(event.slug) && !(sumRunDistance >= race.distance) && <Button className="eframeDisabled" disabled>
                                        <Icon type="exclamation-circle" theme="outlined" /> อีก {race.distance - sumRunDistance} km จะสามารถโหลด e-Frame ได้
                                      </Button>}
                                      <a href={`https://run.${thairunUrl}/${runSlug}?s=${bib}`} target="_blank" className="baseBtn">
                                        <Icon type="eye-o" /> เช็คส่งผลการวิ่ง
                                      </a>
                                      <br/>

                                      {!noEcer && <a href={`https://ecer.thai.run/${ecerSlug}/${bibNumber(ticket.number, _get(event, 'settings.ticket.numberDigits', 4))}`} target="_blank" className="baseBtn">
                                        <Icon type="download" /> ดาวน์โหลด e-Cer
                                      </a>}
                                    </div>}
                                  </div>)
                                })
                                }
                              </div>
                            )}
                          </div>
                        })}
                      </Col>
                    </Row>
                  })}
                </div>
              </Col>
            </Row>
            {eventProducts.length > 0 && <div className="dividedBox">{eventProducts.map(eventProduct => {
              const productType = _get(eventProduct, 'eventProductType')
              return <div key={eventProduct._id}>
                {localeGet(productType, 'name', locale)} (<FormattedMessage id="app.amountBaht" values={{ amount: productType.price }} />)
                <div>
                  {eventProduct.options.map(option => (
                    <div key={option._id}><span className="eventBottomDetailTitle">{localeGet(option, 'question.name', locale)}</span> <span className="eventBottomDetailData">{option.value || option.itemId || option.itemIds}</span></div>
                  ))}
                </div>
              </div>
            })}
            </div>}

            {crossSaleOrderItems.length > 0 && <div className="dividedBox">
              <h1><FormattedMessage id="app.extraItems"/></h1>
              <ExtraItems items={crossSaleOrderItems} locale={locale} event={event}/>
            </div>}

            <div className="dividedBox bigFont">
              {couponCodes && couponCodes.length > 0 && <div style={{ padding: '8px', textAlign: 'right' }}>
                Code: {couponCodes.map(cc => cc.code).join(', ')}
              </div>}
              <div style={{ padding: '8px', textAlign: 'right' }}>
                ค่าสมัคร: <FormattedNumber value={total - (systemFee * ticketCount)} /> บาท
              </div>
              {discountedItemsAmount > 0 && <div style={{ padding: '8px', textAlign: 'right' }}>
                ค่าสินค้าเพิ่มเติม: <FormattedNumber value={discountedItemsAmount} /> บาท
              </div>}
              {discount > 0 && <div style={{ padding: '8px', textAlign: 'right' }}>
                ส่วนลด: - <FormattedNumber value={discount} /> บาท
              </div>}
              {deliveryPrice > 0 && <div style={{ padding: '8px', textAlign: 'right' }}>
                  ค่าจัดส่ง: + <FormattedNumber value={deliveryPrice} /> บาท
                </div>}
              <div style={{ padding: '8px', textAlign: 'right' }} className="totalPrice">
                รวมทั้งสิ้น: <FormattedNumber value={discounted + discountedItemsAmount} /> บาท
              </div>
              {systemFee > 0 && <div style={{ padding: '8px', textAlign: 'right' }}>
                ค่าบริการ: + <FormattedNumber value={systemFee * ticketCount} /> บาท
              </div>}
              {gatewayFee > 0 && !systemFee && <div style={{ padding: '8px', textAlign: 'right' }}>
                ค่าบริการ: + <FormattedNumber value={gatewayFee} /> บาท
              </div>}
              {registration.status === 'paid' && <div style={{ padding: '8px', textAlign: 'right' }} className="totalPrice">
                ชำระแล้ว: <FormattedNumber value={payment.payAmount} /> บาท
              </div>}
              {registration.orders.length > 0 &&
                <div style={{ marginTop: 12 }}>
                  <span style={{ fontSize: 'large' }}>สินค้าที่ซื้อเพิ่มหลังจากสมัครวิ่งสมบูรณ์</span>
                  <ExtraItems items={extraSaleOrderItems} locale={locale} event={event}/>
                  <Table dataSource={registration.orders} pagination={false} rowKey="_id">
                    <Table.Column title={intl.formatMessage({ id: 'app.orderCode' })} key="code" dataIndex="code"
                      render={(code, { _id, status }) =>
                        status === 'paid'
                          ? <Link to={`/orders/${_id}`}>{code} [{{ en: 'Details', zh: 'Details', th: 'รายละเอียด' }[locale]}]</Link>
                          : <Link to={`/orders/${_id}/edit`}>{code} [{{ en: 'Edit', zh: 'Edit', th: 'แก้ไข' }[locale]}]</Link>
                      }
                    />
                    <Table.Column title={{ en: 'Status', zh: 'Status', th: 'สถานะ' }[locale]} key="status" dataIndex="status" width={120} align="right"
                      render={status => <Tag color={orderStatusColors[status]} className="status"><FormattedMessage id={`order.paymentStatus.${status}`} /></Tag>}
                    />
                    <Table.Column title={{ en: 'Amount', zh: 'Amount', th: 'ยอดเงิน' }[locale]} key="amount" dataIndex="amount.discounted" width={90} align="right"
                      render={discounted => <FormattedNumber value={discounted} />}
                    />
                  </Table>
                </div>
              }
            </div>
            {cancelRequests.length > 0 && <div className="dividedBox bigFont">
              <h3>{{ en: 'Cancellation Requests', th: 'การขอยกเลิกการสมัคร' }[locale]}</h3>
              <List
                itemLayout="vertical"
                size="large"
                pagination={false}
                dataSource={cancelRequests}
                renderItem={req => (
                  <List.Item
                    key={req._id}
                    // actions={[<IconText type="star-o" text="156" />, <IconText type="like-o" text="156" />, <IconText type="message" text="2" />]}
                    extra={
                      <div>
                        <Tag {...(req.status === 'completed' && { color: 'green' })}><FormattedMessage id={`app.cancelRequest.status.${req.status}`} /></Tag>
                        {req.refundAmount > 0 && <Tag color="orange"><FormattedMessage id="app.amountBaht" values={{ amount: req.refundAmount }} /></Tag>}
                        {_get(req, 'response.attachmentUrl') && <div>
                            <a href={_get(req, 'response.attachmentUrl')} target="_blank">{{ en: 'Details', th: 'เอกสารแนบ' }[locale]}</a>
                          </div>
                        }
                        {_get(req, 'response.remarks') &&
                          <div style={{ whiteSpace: 'pre-line' }}><FormattedMessage id="app.remarks" tagName="strong" />: {_get(req, 'response.remarks')}</div>
                        }

                      </div>
                    }
                  >
                    <List.Item.Meta
                      // avatar={}
                      title={`[${bibNumber(req.ticket.number)}]\n${_get(req.ticket, 'participant.profile.firstName')} ${_get(req.ticket, 'participant.profile.firstName')}\n(${localeGet(req.ticket, 'ticketType.name', locale)})`}
                      description={`${{ en: 'Date Requested', zh: 'Date Requested', th: 'วันที่ยื่นเรื่อง' }[locale]}: ${moment(req.createdAt).format('Do MMM HH:mm')}`}
                    />
                    <strong>{localeGet(req, 'method.name', locale)}</strong>
                    <div style={{ whiteSpace: 'pre-line' }}>
                      {_get(req, 'options', []).map(option => {
                        const items = _get(option, 'question.items', [])
                        const optionValue = {
                          Open: option.value,
                          Choice: localeGet(items.find(i => i._id === option.itemId), 'value', locale) || option.itemId,
                          MultiChoice: items.filter(i => option.itemIds && option.itemIds.includes(i._id)).map(i => localeGet(i, 'value', locale)).join(', ')
                        }[option.question.kind]
                        const valueFormatted = option.question.inputType === 'date' ? moment(optionValue).format('D MMMM YYYY') : optionValue
                        return <div key={option._id}>{localeGet(option, 'question.name', locale)}: {valueFormatted}</div>
                      })}
                    </div>
                  </List.Item>
                )}
              />
            </div>}
            <div className="dividedBox bigFont" style={{ padding: '8px', textAlign: 'right' }}>
              {cancelRequestEnabled &&
              <Button style={{ marginRight: 6 }} onClick={this.handleCancelRequestModalOpen} >{{ en: 'Request Cancellation', zh: 'Request Cancellation', th: 'ขอยกเลิกการสมัคร' }[locale]}</Button>}
              {/* event.slug === 'forest' && <Link to={`/reg/${registration._id}/edit`}>
                <Button type="primary" style={{ marginRight: '8px' }}>
                  <FormattedMessage id="app.edit" defaultMessage="Edit" />
                </Button>
          </Link>
              */}
              {(event.extraProductCount > 0 && registration.orders.length < _get(event, 'settings.registration.maxOrders', 0) && status === 'paid') && <Button onClick={this.handleNewOrder}>
                {{ en: 'Shop More Items', zh: 'Shop More Items', th: 'ซื้อสินค้าเพิ่มเติม' }[locale]}
              </Button>}&nbsp;
              {registration.status === 'submitted' && <Link to={`/reg/${registration._id}/pay`}>
                <Button type="primary" disabled={expireAt && expired} ><FormattedMessage id="app.pay" defaultMessage="Pay" /></Button>
              </Link>}&nbsp;
              <Link to={`/dashboard`}>
                <Button type="primary" style={{ marginRight: '8px' }}>
                  <FormattedMessage id="app.myRegistrations" defaultMessage="My Registrations" />
                </Button>
              </Link>
            </div>
          </div>
        </Form>
        <Modal
          visible={!!ticketId}
          onCancel={this.handleSubmitRunModalClose}
          onOk={this.handleSubmitRun}
          confirmLoading={this.state.submitting}
          // okText={this.state.submitting ? 'Submitting' : 'Submit'}
        >
          <RunForm wrappedComponentRef={ref => { this.runForm = ref }} ticketId={ticketId} raceId={raceId}/>
        </Modal>
        <Modal
          visible={!!regRefund}
          onCancel={this.handleRefundRequestModalClose}
          onOk={this.handleCreateRefundRequest}
          confirmLoading={this.state.refundRequesting}
          // okText={this.state.submitting ? 'Submitting' : 'Submit'}
        >
          <RefundRequestForm wrappedComponentRef={ref => { this.refundForm = ref }} registration={registration} />
        </Modal>
        <Modal
          visible={!!regCancel}
          onCancel={this.handleCancelRequestModalClose}
          onOk={this.handleCreateCancelRequest}
          confirmLoading={this.state.cancelRequesting}
          // okText={this.state.submitting ? 'Submitting' : 'Submit'}
        >
          <CancelRequestForm wrappedComponentRef={ref => { this.cancelForm = ref }} registration={registration} />
        </Modal>
        <Modal visible={!!runId} footer={null} onCancel={this.handleCloseRun}>
          <Run runId={runId} />
        </Modal>

        <Modal visible={!!removeRunsRaceId}
          onCancel={ () => { this.props.history.push(`/reg/${registration._id}`) } }
          className="responsiveModal"
          title={
            ({
              en: `Select runs to delete`,
              zh: `Select runs to delete`,
              th: `เลือกผลการวิ่งที่จะลบ`
            })[locale]
          }
          footer={null}>
          <RemoveRuns data={this.state.removeRunsData} handleRemoveRun={this.handleRemoveRun} />
        </Modal>

        <Modal visible={!!this.state.popModlRunResult}
          className="ModalRunResult"
          title='ส่งผลการวิ่งสำเร็จ'
          cancelText='กลับหน้าหลัก'
          okButtonProps={{ disabled: true }}
          onCancel={ () => { this.props.history.push(`/reg/${registration._id}`) } }>
          <RunResult data={this.state.modalRunResult} />
        </Modal>

      </Registration>
    )
  }
}

export default RegistrationView



// WEBPACK FOOTER //
// ./src/App/pages/EventRegistration/Registration/Registration.js